import { SwapSideComponent } from './../components/swap-side/swap-side.component';
import { StopwatchModule } from './../../_shared/components/stopwatch/stopwatch.module';
import { TickerComponent } from './../components/ticker/ticker.component';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, inject, } from '@angular/core';
import { Match } from '../../_shared/models/match.model';
import { SbBodyComponent } from '../../scoreboard/sb-body/sb-body.component';
import { Tie } from '../../_shared/models/tie.model';
import { IonicModule, ModalController, Platform } from '@ionic/angular';
import { AddPointButtonComponent } from '../add-point-button/add-point-button.component';
import { OfficialViewService } from '../official-view.service';
import { PointRowComponent } from '../../score-list/point-row/point-row.component';
import { BoardHelpService } from '../../match-tracker/tracker-board/board-help.service';
import { ScoreFormat, SetType } from '../../_shared/models/score-format.model';
import { ClockName } from '../../_shared/models/enums/clock-name.enum';
import { Clock } from '../../_shared/models/clock.model';
import { StopwatchComponent } from '../../_shared/components/stopwatch/stopwatch.component';
import { StartMatchModule } from '../../match-tracker/start-match/start-match.module';
import { StartMatchService } from '../../match-tracker/start-match/start-match.service';
import { Subject, takeUntil } from 'rxjs';
import { MatchDurationModule } from '../../_shared/components/match-duration/match-duration.module';
import { Point } from '../../_shared/models/point.model';
import { Game } from '../../_shared/models/game.model';
import { ClocksService } from '../../clocks/clocks.service';
import { TimeoutModule } from '../../_shared/components/timeout/timeout.module';
import { MatchService } from '../../_core/services/match.service';
import { AddPointSideComponent } from '../add-point-side/add-point-side.component';
import { PickleballTrackerBrainService } from '../../match-tracker/tracker-board/services/pickleball/pickleball-tracker-brain.service';
import { IntPointContainerComponent } from '../../intennse-official-view/int-point-container/int-point-container.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-official-view-for-pickleball',
  templateUrl: './official-view-for-pickleball.component.html',
  styleUrls: ['./official-view-for-pickleball.component.scss'],
  standalone: true,
  imports: [
    SbBodyComponent,
    IonicModule,
    PointRowComponent,
    StopwatchModule,
    SwapSideComponent,
    TimeoutModule,
    StartMatchModule,
    MatchDurationModule,
    AddPointSideComponent,
    IntPointContainerComponent,
    CommonModule
  ]
})

export class OfficialViewForPickleballComponent implements AfterViewInit, OnDestroy, OnInit {
  officialViewService = inject(OfficialViewService);
  private startMatchService = inject(StartMatchService);
  private pickleballTrackerBrainService = inject(PickleballTrackerBrainService);

  private platform = inject(Platform);
  private bhs = inject(BoardHelpService);
  private modalController = inject(ModalController);
  @Input({ required: true}) match!: Match;
  @Input({ required: true}) tie!: Tie;
  @Input({ required: true}) scoreFormat!: ScoreFormat;
  @Input({ required: true}) headerHeight!: number;
  @Output() addPointSideNumber = new EventEmitter<{ sideNumber: number; point?: number }>();
  @Output() undo = new EventEmitter<boolean>;
  @Output() resumeSuspendedMatch = new EventEmitter<boolean>;

  @ViewChild('topRow', { read: ElementRef }) topRow: ElementRef | undefined;
  @ViewChild('scoreboard', { read: ElementRef }) scoreboard: ElementRef | undefined;
  @ViewChild('pointRow', { read: ElementRef }) pointRow: ElementRef | undefined;
  @ViewChild('fixedContent', { read: ElementRef }) fixedContent: ElementRef | undefined;
  @ViewChild('warmUpClock') warmUpClock: StopwatchComponent | undefined;
  @ViewChild('pointBreakClock') pointBreakClock: StopwatchComponent | undefined;
  @ViewChild('setTimeClock') setTimeClock: StopwatchComponent | undefined;
  @ViewChild('timeoutWrapper') timeoutWrapper: ElementRef | undefined;

  rowHeight = 0;
  sideColors = ['#ffffff', '#ffffff'];
  public readonly clockName : typeof ClockName = ClockName;
  private readonly destroy$: Subject<void> = new Subject();

  lastPoint:Point = {} as Point;
  lastGame:Game = {} as Game;
  isTimeoutClock: Clock | undefined;
  matchTimeout: any;
  isGameTypeRallyOrMLP!: boolean;

  constructor(private clocksService: ClocksService,private matchService: MatchService,private cd: ChangeDetectorRef,) {
    this.startMatchService
      .subscribeStartMatch()
      .pipe(
          takeUntil(this.destroy$))
      .subscribe(
          startMatch => {
              if (this.match._id === startMatch.matchId && startMatch.matchActive) {
                  this.calculateRowHeight();
              }
          }
      );
  }

  ngOnInit(): void {
    this.subscriptions();
    this.isGameTypeRallyOrMLP = this.pickleballTrackerBrainService.getSetType(this.match) === SetType.RALLY || this.pickleballTrackerBrainService.getSetType(this.match) === SetType.MLP
    
    this.isTimeoutClock = this.getClock(ClockName.TIMEOUT);
      if(this.match?.sets.length > 0 && this.isTimeoutClock){
            this.matchTimeout = this.match?.sets && this.clocksService.getTimeoutValuesFromSet(this.match?.sets?.[this.match.sets?.length - 1], this.match);
      }
  }

  subscriptions(){
      this.matchService
         .subscribeScoreUpdated()
         .pipe(takeUntil(this.destroy$))
         .subscribe((match: Match) => {
           if (this.match._id === match._id) {
            this.match = {
                    ...match,
                    clocks: this.match.clocks
                };
            this.isTimeoutClock = this.getClock(ClockName.TIMEOUT);        
             this.matchTimeout = match?.score?.sets?.[this.match?.score?.sets?.length - 1]?.timeout;

              // Update areSidesReversed for badminton when sides are swapped
              if(this.match.discipline === 'BADMINTON'){
                const areSidesReversed = this.bhs.getLastPoint(this.match)?.extensions?.find(ext => ext.name === 'areSidesReversed')?.value;
                if(areSidesReversed !== undefined) {
                  this.officialViewService.areSidesReversed = areSidesReversed;
                }
              }
             this.calculateRowHeight();
           }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnChanges(changes:SimpleChanges): void {
    if (changes.match && changes.match.currentValue) {
      this.match = {...this.match, ...changes.match.currentValue}
      this.lastPoint = {...this.lastPoint, ...this.getLastPoint()}
      this.lastGame = {...this.lastGame, ...this.getLastGame()}
      // Update areSidesReversed for badminton when sides are swapped
      if(this.match.discipline === 'BADMINTON'){
        const areSidesReversed = this.bhs.getLastPoint(this.match)?.extensions?.find(ext => ext.name === 'areSidesReversed')?.value;
        if(areSidesReversed !== undefined) {
          this.officialViewService.areSidesReversed = areSidesReversed;
        }
      }
    }
    
    if (changes.tie && changes.tie.currentValue) {
      this.tie = changes.tie.currentValue;
      this.cd.detectChanges();
    }
    this.calculateRowHeight();
  }

  addPoint(sideNumber: number, point?:number): void {
    this.addPointSideNumber.emit({ sideNumber, point });
    this.pointBreakClock?.clearClock();
    this.pointBreakClock?.startClock();
    this.setTimeClock?.updateClockOverSocket();
  }

  addPointScore(sideNumber, point: number){
    this.addPoint(sideNumber, point)
  }

  emitUndo() {
    this.undo.emit(true);
  }

  ngAfterViewInit(): void {
    // TODO How can we avoid using settimeout?
      if (this.match.matchStatus !== 'TBP') {
        this.calculateRowHeight();
      }
  }

  private calculateRowHeight() {
    setTimeout(() => {
      const windowHeight: number = this.platform.height();
      const fixedContentHeight = this.fixedContent?.nativeElement?.offsetHeight;
      const availableHeight = windowHeight - (this.headerHeight + fixedContentHeight) - (this.match.discipline === 'SQUASH' ? 0 : 64);
      this.rowHeight = availableHeight;
    }, 100)
  }

  getLastPoint() {
    return this.bhs.getLastPoint(this.match);
  }

  getLastGame() {
    return this.bhs.getLastGame(this.match);
  }

  getClock(clockName: ClockName): Clock | undefined {
    return this.match.clocks.find(c => c.name === clockName);
  }

  async confirmDismiss(): Promise<boolean> {
    const shouldDismiss = confirm('Are you sure you want to end timeout?');
    return shouldDismiss; // Returning false prevents dismissal
  }

  onTimeoutEnd(){
    this.pointBreakClock?.clearClock();
  }

    onTimeoutStarted(){
    this.setTimeClock?.pauseClock();
    this.pointBreakClock?.pauseClock();
  }

    onTimeoutUndo(){
    this.pointBreakClock?.startClock();
    this.setTimeClock?.startClock();
  }
}
